// extracted by mini-css-extract-plugin
export default {"map":"map_map__zBfMK","container":"map_container__Gp6Wx","ymap":"map_ymap__kbL0l","zoomButton":"map_zoomButton__ahe9D"};